import { render } from "./HeroiconsOutlineUpload.vue?vue&type=template&id=4902c460"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUpload.vue"]])

export default __exports__